export const playCopy = {
  play_subnav_title: "Playground",
  play_subnav_config: "Konfiguracja TS",
  play_config_language_blurb: "Który język powinien być użyty w edytorze",
  play_subnav_examples: "Przykłady",
  play_subnav_examples_close: "Zamknij",
  play_subnav_whatsnew: "Co nowego",
  play_subnav_settings: "Ustawienia",
  play_settings_tabs_settings: "Karty paska bocznego",
  play_downloading_typescript: "Pobieranie TypeScript...", // when loading
  play_downloading_version: "Wersja...", // when loading
  play_toolbar_run: "Uruchom",
  play_toolbar_export: "Eksportuj",
  play_toolbar_share: "Udostępnij",
  play_sidebar_js: ".JS",
  play_sidebar_dts: ".D.TS",
  play_sidebar_errors: "Błędy",
  play_sidebar_errors_no_errors: "Brak błędów",
  play_sidebar_logs: "Logi",
  play_sidebar_logs_no_logs: "Brak logów",
  play_sidebar_options: "Opcje",
  play_sidebar_options_restart_required: "Odświeżenie przeglądarki wymagane",
  play_sidebar_options_disable_ata: "Wyłącz ATA",
  play_sidebar_options_disable_ata_copy:
    "Wyłącz automatyczne pozyskiwanie typów dla importu i wymagań.",
  play_sidebar_options_disable_save: "Wyłącz opcję Save-On-Type",
  play_sidebar_options_disable_save_copy:
    "Wyłącz zmianę adresu URL podczas pisania.",
  play_sidebar_plugins: "Wtyczki",
  play_sidebar_featured_plugins: "Polecane wtyczki",
  play_sidebar_plugins_options_external:
    "Wtyczki innych firm <a href='https://www.npmjs.com/search?q=keywords:playground-plugin'>z npm</a>",
  play_sidebar_plugins_options_external_warning:
    "Ostrzeżenie: kod wtyczek pochodzi od stron trzecich.",
  play_sidebar_plugins_options_modules: "Niestandardowe moduły npm",
  play_sidebar_plugins_options_modules_placeholder: "Nazwa modułu z npm.",
  play_sidebar_plugins_plugin_dev: "Plugin Dev",
  play_sidebar_plugins_plugin_dev_option:
    "Połącz się z <code>localhost:5000</code>",
  play_sidebar_plugins_plugin_dev_copy:
    "Automatycznie spróbuj połączyć się z wtyczką playground w trybie programowania. Mozesz zacząć od <a href='/dev/playground-plugins/' title='Link do strony o wtyczkach Playground'>tworzenia wtyczki tutaj</a>.",
  play_export_report_issue: "Zgłoś problem GitHub związany z TypeScript",
  play_export_tweet_md: "Tweetuj link do Playground",
  play_export_copy_md: "Skopiuj jako problem Markdown",
  play_export_copy_link: "Skopiuj jako łącze Markdown",
  play_export_copy_link_preview: "Skopiuj jako łącze Markdown z podglądem",
  play_export_tsast: "Otwórz w TypeScript AST Viewer",
  play_export_sandbox: "Otwórz w CodeSandbox",
  play_export_stackblitz: "Otwórz w StackBlitz",
  play_export_clipboard: "URL skopiowany do schowka",
  play_clear_logs: "Logi wyczyszczone",
  play_run_js: "Wykonany JavaScript",
  play_run_ts: "Wykonany transpliowany TypeScript",
  play_run_js_fail: "Wykonany JavaScript nie powiódł się:",
  play_default_code_sample: `// Witaj w TypeScript Playground, to jest strona,
// która daje Ci szanse na pisanie, dzielenie się oraz naukę TypeScript.

// Można o tym pomyśleć na trzy sposoby:
//
//  - Miejsce do nauki języka TypeScript w miejscu, w którym nic nie może się zepsuć
//  - Miejsce do eksperymentowania ze składnią TypeScript i udostępniania adresów URL innym osobom
//  - Piaskownica do eksperymentowania z różnymi funkcjami kompilatora języka TypeScript

const anExampleVariable = "Witaj Świecie"
console.log(anExampleVariable)

// Aby dowiedzieć się więcej o języku, kliknij powyżej w sekcji „Przykłady” lub „Co nowego”.
// W przeciwnym razie zacznij od usunięcia tych komentarzy, a świat stanie się Twoim placem zabaw.
  `,

  play_sidebar_js_title: "JavaScript",
  play_sidebar_js_blurb: "Pokazuje transpilowany JS",

  play_sidebar_dts_title: "Pliki definicji",
  play_sidebar_dts_blurb: "Pokazuje wynik .d.ts twojego kodu",

  play_sidebar_err_title: "Błędy kompilatora",
  play_sidebar_err_blurb: "Wyświetla pełne błędy kompilatora",

  play_sidebar_run_title: "Uruchom JavaScript w przeglądarce",
  play_sidebar_run_blurb: "Pokazuje wynik uruchomienia JavaScript w edytorze",

  play_sidebar_plugins_title: "Zarządzaj wtyczkami Playground",
  play_sidebar_plugins_blurb:
    "Obsługuje dodawanie / usuwanie rozszerzeń innych firm do Playground",

  play_sidebar_ast_title: "[WIP] AST Viewer",
  play_sidebar_ast_blurb: "Sprawdź TypeScript AST",

  // Notes:
  // Compiler flag information is all from the tsconfig reference info
}
